import { useEffect, useState } from 'react'
import QRCode from 'qrcode'
import { fetchSchaufensterQr } from '../lib/api'

/** Sicherheitshalber auch zwischendurch nachsehen — falls ein Abruf zum Wechsel ausfiel. */
const NACHSEHEN_MS = 60_000

/**
 * Der QR-Code im Schaufenster. Er wechselt alle paar Minuten (der Worker
 * rechnet ihn aus der Zeit, routes/intro.ts → `/qr`): Steuern kann nur, wer
 * gerade davorsteht — ein abfotografierter Code taugt kurz darauf nicht mehr.
 * Schwarz auf Weiß und groß, damit Handys ihn auch durch die Scheibe lesen.
 */
export function SchaufensterQr({ groesse }: { groesse: number }) {
  const [bild, setBild] = useState<string | null>(null)
  const [fehler, setFehler] = useState(false)

  useEffect(() => {
    let aktiv = true
    let wechsel: ReturnType<typeof setTimeout> | undefined
    const holen = async () => {
      clearTimeout(wechsel)
      try {
        const qr = await fetchSchaufensterQr()
        const png = await QRCode.toDataURL(qr.url, {
          width: groesse * 2,
          margin: 1,
          errorCorrectionLevel: 'M',
          color: { dark: '#000000', light: '#ffffff' },
        })
        if (!aktiv) return
        setBild(png)
        setFehler(false)
        // Kurz nach dem Wechsel den neuen holen.
        wechsel = setTimeout(() => void holen(), qr.wechseltInMs + 1500)
      } catch {
        if (aktiv) setFehler(true)
      }
    }
    void holen()
    const id = setInterval(() => void holen(), NACHSEHEN_MS)
    return () => {
      aktiv = false
      clearTimeout(wechsel)
      clearInterval(id)
    }
  }, [groesse])

  return (
    <div className="flex flex-col items-center gap-4">
      <div
        className="rounded-3xl bg-white p-4 shadow-[0_0_48px_var(--color-accent)]"
        style={{ width: groesse + 32, height: groesse + 32 }}
      >
        {bild ? (
          <img src={bild} alt="QR-Code zum Steuern" width={groesse} height={groesse} />
        ) : (
          <div
            className="flex h-full w-full items-center justify-center text-center text-sm text-neutral-500"
            role="status"
          >
            {fehler ? 'QR-Code nicht erreichbar — Schlüssel in der Adresse prüfen' : 'Lädt …'}
          </div>
        )}
      </div>
      <p className="text-center text-3xl font-semibold leading-tight">Scan mich mit deinem Handy</p>
      <p className="-mt-2 text-center text-xl text-text-muted">und steuere das Schaufenster</p>
    </div>
  )
}
